<template>
	<div class="common-detail" v-if="details">
		<div class="common-detail.logo" data-aos="fade-right">
			<img :src="details.icon" alt="">
		</div>
		<div class="common-detail.intro" data-aos="fade-left">
			<h3>{{details.name}}</h3>
			<p>{{details.desc}}</p>
			<p v-show="details.date">发布时间：{{details.date}}</p>
			<ul class="common-detail.intro.detail">
				<li class="common-detail.intro.platform" v-if="details.type== '商标'">
					<div :class="{'+tradeWidth':details.type== '商标'}">入驻平台：<span v-for="(platform,index) in details.platforms" :key="index">{{platFormLIsts[platform - 1]}}</span></div>
				</li>
				<li class="common-detail.intro.platform" v-else-if="details.type== '专利'">
					<div>专利号：{{details.number}}</div>
					<div v-show="details.research">研究领域：{{details.research}}</div>
				</li>
				<li class="common-detail.intro.type" v-show="details.tradeType">{{details.type}}类型: {{details.tradeType}}</li>
				<li class="common-detail.intro.tel">
					<div>
						<span><img src="../assets/trademarks/user.png" alt=""></span>
						<p><span>申请人</span><span>{{details.Application}}</span></p>
					</div>
					<div>
						<span><img src="../assets/trademarks/tel.png" alt=""></span>
						<p>
							<span>电话 </span><span>{{details.tel}}</span>
						</p>
					</div>
				</li>
			</ul>
			
			<div class="common-detail.intro.button">
			   <Button :btnText="{text:'查看价格',subText:details.price}"></Button>
			   <a download="说明书下载" :href="details.link" v-show="details.type == '专利'" target="_blank">说明书下载</a>
			</div>
		</div>
	</div>
</template>

<script>
	import Button from '../components/button.vue'
	
	export default{
		components:{
			Button
		},
		props:['details'],
		data(){
			return{
				platFormLIsts:['京东','天猫','大型超市','一号店','美丽说','聚美优品'],
			
			}
		}
	}
</script>

<style lang="scss">
	@include component(common-detail) {
		width: 1200px;
		margin: 20px auto;
		height: 424px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
		padding: 38px 30px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #333333;
		font-size: 16px;

		@include part(logo) {
			width: 380px;
			height: 346px;
			border: 1px solid rgba(242, 242, 242, 1);
			display: flex;
			justify-content: center;
			align-items: center;

			img {
				display: block;
				width: 100%;
				height: 100%;
				object-fit: contain;
				object-position: center;
			}
		}

		@include part(intro) {
			display: flex;
			flex-direction: column;
			width: 720px;
			height: 100%;
			margin: auto;

			>h3 {
				margin: 0;
				font-size: 30px;
				text-align: left;
			}

			>p {
				text-align: left;
				font-size: 16px;
				color: #999999;
				line-height: 30px;
				overflow: hidden;
				// text-overflow: ellipsis;
				// white-space: nowrap;
				&:nth-child(2){
					max-height: 43px;
					line-height: 20px;
				}
			}

			@include part(detail) {
				width: 100%;
				height: 160px;
				background: rgba(247, 247, 247, 1);
				margin-top: 17px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: flex-start;
				font-size: 16px;
				padding-left: 20px;
				color: #999999;

				li {
					width: 100%;
					display: flex;
					justify-content: flex-start;
				}
			}

			@include part(platform) {
				
				>div{
					width: 50%;
					text-align: left;
					display: flex;
					justify-content: flex-start;
					align-items: center;
					span {
						display: inline-block;
						width: 78px;
						height: 26px;
						line-height: 26px;
						border-radius: 13px;
						border: 1px solid #b4dbf4;
						background-color: #f1f7fb;
						color: #035F99;
						margin-right: 5px;
						text-align: center;
					}
				}
				
				display: flex;
				justify-content: space-between;
				align-items: center;
				@include tweak(tradeWidth){
					width: 100%;
				}
			}

			@include part(type) {
				margin: 15px 0;
			}

			@include part(tel) {
				>div {
					width: 50%;
					text-align: left;
					display: flex;
					justify-content: flex-start;
					align-items: center;

					>p {
						display: flex;
						flex-direction: column;

						span {
							display: inline-block;
							font-size: 14px;

							&:nth-child(2) {
								font-size: 16px;
								color: #333333;
							}
						}
					}

					>span {
						display: inline-block;
						margin-right: 5px;
					}
				}
			}

			@include part(button) {
				width: 100%;
				display: flex;
				margin-top: 10px;
				>a{
					display: inline-block;
					width:170px;
					height:60px;
					background:rgba(242,242,242,1);
					border-radius:5px;
					margin-left: 63px;
					line-height: 60px;
					color: #333333;
					position: relative;
					padding-left:35px;
					&:before{
						content: '';
						display: inline-block;
						width: 23px;
						height: 24px;
						background: url(../assets/trademarks/download.png);
						position: absolute;
						top: 18px;
						left:35px
						
					}
				}
				
			}
		}

	}
</style>
